<template>
  <v-container fluid>
    <section>
      <!-- KPI summary cards -->
      <KpiCards class="mb-4" :items="kpiItems" :loading="loadingSummary" :skeleton="4" />

      <data-table
        :headers="headers"
        :items="reportCategories"
        commit="SET_REPORT_CATEGORIES"
        :viewItem="viewItem"
      >
        <div slot="activator" class="row mb-4">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
            <v-card-title class="px-0 pt-0 ps-products-title">
              {{ $t("category") }}
            </v-card-title>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <TextSearch
              v-model="search"
              @search="fetchItem()"
              @onClear="
                search = '';
                fetchItem();
              "
            />
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
            <DatePicker
              :dense="true"
              :placeholder="false"
              label="date"
              v-model="date"
            />
          </div>
          <v-spacer />
        </div>
      </data-table>
      <app-custom-dialog v-model="dialog" :footer="false" title="description">
        <div slot="activator">
          <v-row>
            <v-col cols="4">{{ $t("id") }}</v-col>
            <v-col cols="8">{{ form.id }}</v-col>
            <v-col cols="4">{{ $t("lao_name") }}</v-col>
            <v-col cols="8">{{ form.la_name }}</v-col>
            <v-col cols="4">{{ $t("eng_name") }}</v-col>
            <v-col cols="8">{{ form.en_name }}</v-col>
            <v-col cols="4">{{ $t("sum_stock") }}</v-col>
            <v-col cols="8">{{ form.products_sum_stock }}</v-col>
            <v-col cols="4">{{ $t("sale_sum_qty") }}</v-col>
            <v-col cols="8">{{ form.products_sale_sum_qty }}</v-col>
            <v-col cols="4">{{ $t("sale_sum_total_price") }}</v-col>
            <v-col cols="8">{{
              form.products_sale_sum_total_price | NumberFormat
            }}</v-col>

            <v-col cols="4">{{ $t("created_at") }}</v-col>
            <v-col cols="8">{{ form.created_at | moment }}</v-col>
          </v-row>
        </div>
      </app-custom-dialog>
      <!-- AppLoading -->
      <app-loading :overlay="overlay" />
    </section>
  </v-container>
</template>

<script>
import DataTable from "@/components/DataTable";
import { mapGetters, mapActions } from "vuex";
import TTextField from "@/components/global/TextField";
import { customerValidate } from "@/validations/shop";
import { myMixin } from "@/mixin/main";
import { categoryHead } from "@/utils/head";

// get today date
const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .substr(0, 10);

export default {
  mixins: [customerValidate, myMixin],

  data: () => ({
    dialog: false,
    overlay: false,
    search: "",
    date: today,
    form: {},
    loadingSummary: true,
    summaries: [],
  }),
  async created() {
    await Promise.all([this.fetchItem(), this.fetchSummaries()]);
  },
  components: { DataTable, TTextField },
  computed: {
    kpiItems() {
      return (this.summaries || []).map((item, index) => ({
        key: index,
        title: item.title,
        icon: item.icon,
        value: item.total ?? 0,
        note: item.description ? this.$t(item.description) : "",
      }));
    },
    ...mapGetters({
      reportCategories: "index/reportCategories",
    }),
    headers() {
      return categoryHead(this);
    },
  },

  watch: {
    date() {
      this.fetchItem();
      this.fetchSummaries();
    },
  },

  methods: {
    ...mapActions({
      fetch: "index/fetch",
    }),
    async fetchItem() {
      const body = {
        that: this,
        url: `report_categories?q=${this.search}&date=${this.date}`,
        commit: "SET_REPORT_CATEGORIES",
      };
      await this.fetch(body);
    },

    async fetchSummaries() {
      this.loadingSummary = true;
      try {
        const { data } = await this.$http.get(
          `get_summary_report_categories?date=${this.date || ""}`
        );
        if (data && data.status) {
          this.summaries = data.data;
        }
      } catch (e) {
        console.error("fetchSummaries error", e);
      } finally {
        this.loadingSummary = false;
      }
    },

    viewItem(item) {
      this.form = item;
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped>
.ps-products-title {
  font-size: 1.25rem;
  font-weight: 900;
  color: #141021;
}
</style>
